'use client';

import { GetMovieShowtimesRequest } from '@/types/paged-requests/movie-paged-request';
import { MovieShowtimesResponse } from '@/types/showtimes';
import { commonFetch, CommonFetchResponse } from '@/utils/common-fetch';
import { buildUrlWithParams } from '@/utils/url-params';

class MovieShowtimesApiService {
  async getAvailableDates(movieId: number, zipCode?: string, signal?: AbortSignal): Promise<CommonFetchResponse<string[]>> {
    const url = `/papi/movies/${movieId}/showtime-dates`;
    return await commonFetch<string[]>(
      buildUrlWithParams(url, zipCode ? { zipCode } : {}),
      signal ? { signal } : undefined
    );
  }

  async getShowtimes(request: GetMovieShowtimesRequest, signal?: AbortSignal): Promise<CommonFetchResponse<MovieShowtimesResponse>> {
    const params: Omit<GetMovieShowtimesRequest, 'date' | 'movieId'> & { date?: string; } = {};

    if (request.date) {
      const year = request.date.getFullYear();
      const month = String(request.date.getMonth() + 1).padStart(2, '0');
      const day = String(request.date.getDate()).padStart(2, '0');
      params.date = `${year}-${month}-${day}`;
    }
    if (request.zipCode) {
      params.zipCode = request.zipCode;
    }
    if (request.pageSize) {
      params.pageSize = request.pageSize;
    }

    const url = `/papi/movies/${request.movieId}/showtimes`;
    const response = await commonFetch<MovieShowtimesResponse>(buildUrlWithParams(url, params), signal ? { signal } : undefined);
    return response;
  }
}

export const movieShowtimesApiService = new MovieShowtimesApiService();
